import { withMotion } from '@hoc/withMotion';
import NextButton from '@stories/Components/Buttons/NextButton/NextButton';
import PrevButton from '@stories/Components/Buttons/PrevButton/PrevButton';
import React from 'react';
import { useInterval } from 'react-use';
import S from './HomepageHero.styles';
import HomepageHeroSlide from './HomepageHeroSlide/HomepageHeroSlide';
import SvgHtaHomepageBg from '!file-loader!@img/hta-banner-bg.jpg';
const HomepageHero = ({ autoplay, items, themeOption }) => {
    const [isPaused, setIsPaused] = React.useState(autoplay === 0);
    const [activeId, setActiveId] = React.useState(items[0].id);
    const activeIndex = items.findIndex((item) => item.id === activeId);
    // Autoplay if enabled.
    useInterval(() => {
        if (activeIndex === items.length - 1) {
            setActiveId(items[0].id);
        }
        else {
            setActiveId(items[activeIndex + 1].id);
        }
    }, isPaused ? null : autoplay);
    return (React.createElement(S.Container, { flush: "both" },
        React.createElement(S.HTAGraphicWrapper, null,
            React.createElement("img", { src: SvgHtaHomepageBg })),
        React.createElement(S.Inner, null,
            React.createElement(S.ItemList, null, items.map((item, index) => (React.createElement(HomepageHeroSlide, { key: item.id, ...item, active: activeId === item.id, loading: index === 0 ? 'eager' : 'lazy', themeOption: themeOption })))),
            items.length > 1 && (React.createElement(React.Fragment, null,
                React.createElement(S.Navigation, null, items.map((item, index) => (React.createElement(S.NavigationItem, { key: item.id, "aria-current": item.id === activeId, onClick: (event) => {
                        event.preventDefault();
                        setActiveId(item.id);
                        setIsPaused(true);
                    } },
                    React.createElement("span", null,
                        "Go to slide ",
                        index + 1))))),
                React.createElement(S.Controls, null,
                    React.createElement(PrevButton, { onClick: (event) => {
                            event.preventDefault();
                            if (activeIndex === 0) {
                                return;
                            }
                            const prevItem = items[activeIndex - 1];
                            setActiveId(prevItem.id);
                            setIsPaused(true);
                        }, disabled: activeIndex === 0, themeOption: "green" }),
                    React.createElement(NextButton, { onClick: (event) => {
                            event.preventDefault();
                            if (activeIndex === items.length - 1) {
                                return;
                            }
                            const nextItem = items[activeIndex + 1];
                            setActiveId(nextItem.id);
                            setIsPaused(true);
                        }, disabled: activeIndex === items.length - 1, themeOption: "green" })))))));
};
export default withMotion(HomepageHero);
